import { lazy, Suspense, useState } from 'react';
import ErrorBoundary from 'components/ErrorBoundary';
import { useTranslation } from 'i18n';
import { noteTryOnOpened } from 'services/tryon';

// Everything heavy (the panel, the engine and MediaPipe itself) loads only
// after the shopper taps "Try it on" (R8.5).
const TryOnPanel = lazy(() => import('./TryOnPanel'));

/** R8: shown only when the product detail carries a try-on config (its
 * module supports try-on AND the store's plan has module.tryon). */
export default function TryOnButton({ product }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const cfg = product?.tryon;
  if (!cfg || !cfg.type) return null;

  return (
    <>
      <button
        type="button"
        data-testid="tryon-button"
        onClick={() => {
          setOpen(true);
          noteTryOnOpened(product.id);
        }}
        className="w-full inline-flex items-center justify-center gap-2 rounded-full border border-store-cta px-7 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-store-cta transition hover:bg-surface-2 active:scale-[0.98] dark:text-text dark:border-border"
      >
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
          <path d="M4 8V6a2 2 0 0 1 2-2h2M16 4h2a2 2 0 0 1 2 2v2M20 16v2a2 2 0 0 1-2 2h-2M8 20H6a2 2 0 0 1-2-2v-2" />
          <circle cx="12" cy="12" r="3.2" />
        </svg>
        {t('tryon.button')}
        {cfg.beta && <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] text-amber-900">{t('tryon.beta')}</span>}
      </button>
      {open && (
        <ErrorBoundary fallback={null}>
          <Suspense fallback={null}>
            <TryOnPanel product={product} config={cfg} onClose={() => setOpen(false)} />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
}
